import { useNavigate } from "react-router-dom";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@altimateai/lego";
import { useIntercom } from "react-use-intercom";
import { logoutUser, isServiceUser } from "../../services/auth";
import { useState } from "react";
import { UserProfileImage } from "../../components/profile";
import { signOut } from "supertokens-auth-react/recipe/session";
import { isSSOEnabled } from "@/helpers/tenant";
import UserGroupSelector from "../settings/components/userGroups/UserGroupSelector";
import ProductTour from "./ProductTour";
import CompanySwitcher from "../../components/CompanySwitcher";
import { useAppState } from "@/modules/app/useAppContext";
import { Stack } from "@altimateai/lego";
import { ImpersonationDialog } from "@/pages/home/impersonation/ImpersonationDialog";
import { getImpersonationDetails } from "@/services/auth";
import { ImpersonatedUserBanner } from "@/pages/home/impersonation/ImpersonatedUserBanner";
import { Breadcrumbs } from "@/components/breadcrumbs";

const Header = () => {
  const navigate = useNavigate();
  const { hardShutdown } = useIntercom();
  const ssoMode = isSSOEnabled();
  const [isCompanySwitcherOpen, setIsCompanySwitcherOpen] = useState(false);
  const [isImpersonationDialogOpen, setIsImpersonationDialogOpen] = useState(false);

  const { companyInfo, enableTenantSwitching, loggedinUser: user } = useAppState();

  const impersonatedUser = getImpersonationDetails();

  return (
    <div
      className={
        "al-w-full al-flex al-items-center al-justify-between bg-white al-px-4 al-py-2 al-z-[40]"
      }
    >
      <Breadcrumbs />
      <Stack direction="row" align="center" gap="sm" className="al-ml-auto">
        <ProductTour />
        <UserGroupSelector />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Stack direction="row" align="center" gap="md" className="cursor-pointer">
              <div>{user?.first_name || ""}</div>
              <div className="al-relative">
                <UserProfileImage size="xs" />
                {impersonatedUser && (
                  <span className="al-absolute al-top-0 al-right-0 -al-mt-1 -al-mr-1 al-w-3 al-h-3">
                    <span className="al-absolute al-inset-0 al-animate-ping al-rounded-full al-bg-orange-400 al-opacity-75"></span>
                    <span className="al-absolute al-rounded-full al-bg-orange-600  al-w-3 al-h-3"></span>
                  </span>
                )}
              </div>
            </Stack>
          </DropdownMenuTrigger>

          <DropdownMenuContent className="al-max-w-[350px]">
            <ImpersonatedUserBanner />
            {isServiceUser() && (
              <>
                <DropdownMenuItem onClick={() => setIsImpersonationDialogOpen(true)}>
                  Impersonate User
                </DropdownMenuItem>
                <DropdownMenuSeparator />
              </>
            )}
            {enableTenantSwitching &&
              companyInfo &&
              companyInfo.other_tenants_in_group.length > 0 && (
                <DropdownMenuItem
                  onClick={(e: React.MouseEvent) => {
                    e.stopPropagation();
                    setIsCompanySwitcherOpen(true);
                  }}
                >
                  Switch Tenants
                </DropdownMenuItem>
              )}
            <DropdownMenuItem
              onClick={async (e: React.MouseEvent) => {
                e.stopPropagation();
                logoutUser();
                if (ssoMode) {
                  await signOut();
                }
                hardShutdown();
                navigate("/login");
              }}
            >
              Logout
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </Stack>
      <ImpersonationDialog
        open={isImpersonationDialogOpen}
        onOpenChange={setIsImpersonationDialogOpen}
      />
      <CompanySwitcher
        isOpen={isCompanySwitcherOpen}
        onClose={() => setIsCompanySwitcherOpen(false)}
      />
    </div>
  );
};

export { Header };
